import { render, staticRenderFns } from "./DialogBotOnePlatformPolicyDetail.vue?vue&type=template&id=0c82b0b0&"
import script from "./DialogBotOnePlatformPolicyDetail.vue?vue&type=script&lang=js&"
export * from "./DialogBotOnePlatformPolicyDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports